import { render, staticRenderFns } from "./CSubjectAndCategory.vue?vue&type=template&id=7b7dc7ab&scoped=true&"
import script from "./CSubjectAndCategory.vue?vue&type=script&lang=js&"
export * from "./CSubjectAndCategory.vue?vue&type=script&lang=js&"
import style0 from "./CSubjectAndCategory.vue?vue&type=style&index=0&id=7b7dc7ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7dc7ab",
  null
  
)

export default component.exports